module.exports = __webpack_public_path__ + "static/img/thzyfw.b5a56d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thzyfw.png
// module id = o1gV
// module chunks = 0